<template>
<div class="page auth-page quiz-page">
	<background-image
		type="interval"
		:interval="20000"
	/>
	<div class="modal-window content">
		<div class="modal-content">
			<grid>
				<img src="@/assets/images/logo.svg" alt="logo" class="logo">
			</grid>
			<grid>
				<grid-item size="1/1">
					<h5>Help us to get to know you better</h5>
				</grid-item>
			</grid>
			<quiz />
		</div>
	</div>
</div>
</template>

<script>
import Quiz from './components/Quiz'
import BackgroundImage from '@/components/main/BackgroundImage'

export default {
	components: {
		Quiz,
		BackgroundImage
	}
}
</script>

<style lang="scss">
.quiz-page {
	.content {
		height: 500px;
		top: 39% !important;
	}
	h5 {
		color: #141a21;
		margin: 0 0 10px;
		text-transform: uppercase;
	}
	.logo {
		margin: 0 auto 10px !important;
	}

	p {
		text-align: left;
	}
}
</style>
